"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderVoucher = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const components_1 = require("./components");
function OrderVoucher({ quantity, currency, value, }) {
    return ((0, jsx_runtime_1.jsxs)(components_1.ProductWrap, Object.assign({ templateColumns: "1fr auto", templateRows: "auto", gap: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(components_1.ProductTitle, { children: "Voucher" }), (0, jsx_runtime_1.jsxs)(components_1.ProductPrice, { children: [(0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span" }, { children: [quantity, " x"] })), (0, utils_1.formatPrice)(value, { currency })] })] })));
}
exports.OrderVoucher = OrderVoucher;
